module.exports = __webpack_public_path__ + "img/ic_file_bgreen.0bf92893.svg";